export default __webpack_public_path__ + "static/media/phone.96021bcf.svg";